module.exports = __webpack_public_path__ + "static/media/event-img.50452c68.jpg";